import type { Component } from 'solid-js';

const viteEnvironment =
  (import.meta as ImportMeta & { env?: Record<string, string | boolean | undefined> }).env ?? {};

/**
 * The native package version and source build ID are injected by the frontend
 * build when available. Fallbacks keep browser previews and component tests
 * useful without pretending they are store builds.
 */
const appVersion = String(viteEnvironment.VITE_CHOREPOP_APP_VERSION ?? '0.3.0').trim() || '0.3.0';
const buildId = String(viteEnvironment.VITE_CHOREPOP_BUILD_ID ?? 'local').trim() || 'local';

export const AppVersionFooter: Component = () => (
  <p class="app-version-footer" aria-label={`ChorePop version ${appVersion}, build ${buildId}`}>
    ChorePop v{appVersion} · build {buildId}
  </p>
);
